// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AssetClassFromJSON, AssetClassToJSON, } from './';
export function ManagerFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'knownAs': !exists(json, 'knownAs') ? undefined : json['knownAs'],
        'ticker': !exists(json, 'ticker') ? undefined : json['ticker'],
        'assetClasses': !exists(json, 'assetClasses') ? undefined : json['assetClasses'].map(AssetClassFromJSON),
        'city': !exists(json, 'city') ? undefined : json['city'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'assetsUnderManagement': !exists(json, 'assetsUnderManagement') ? undefined : json['assetsUnderManagement'],
        'creationDate': !exists(json, 'creationDate') ? undefined : new Date(json['creationDate']),
        'referenceDate': !exists(json, 'referenceDate') ? undefined : new Date(json['referenceDate']),
        'latestCapitalAccountReportedDate': !exists(json, 'latestCapitalAccountReportedDate') ? undefined : new Date(json['latestCapitalAccountReportedDate']),
        'modificationDate': !exists(json, 'modificationDate') ? undefined : new Date(json['modificationDate']),
    };
}
export function ManagerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'knownAs': value.knownAs,
        'ticker': value.ticker,
        'assetClasses': value.assetClasses === undefined ? undefined : value.assetClasses.map(AssetClassToJSON),
        'city': value.city,
        'country': value.country,
        'currency': value.currency,
        'url': value.url,
        'assetsUnderManagement': value.assetsUnderManagement,
        'creationDate': value.creationDate === undefined ? undefined : value.creationDate.toISOString(),
        'referenceDate': value.referenceDate === undefined ? undefined : value.referenceDate.toISOString(),
        'latestCapitalAccountReportedDate': value.latestCapitalAccountReportedDate === undefined ? undefined : value.latestCapitalAccountReportedDate.toISOString(),
        'modificationDate': value.modificationDate === undefined ? undefined : value.modificationDate.toISOString(),
    };
}
